// 首先引入Mock
const Mock = require('mockjs')

const getOpList = [
    {
        id: '@increment', // 随机生成标识
        zh_name: '我要订舱',
        en_name: 'RESERVATION'
    },
    {
        id: '@increment', // 随机生成标识
        zh_name: '发送舱单',
        en_name: 'SEND MANIFEST'
    },
    {
        id: '@increment', // 随机生成标识
        zh_name: '发送VGM',
        en_name: 'SEND VGM'
    }
]
const messageList = []
const count = 15
// 生成30条模拟数据
for (let i = 0; i < count; i++) {
  // 使用 Mock.mock 函数拦截请求
  messageList.push(Mock.mock({
    id: '@increment', // 随机生成标识
    date: Mock.Random.date('yyyy-MM-dd'),
    title: '@csentence()'
  }))
}
// 订舱推荐
const getRecommendationList = [
  {
      id: '@increment', // 随机生成标识
      title: '订舱推荐',
      type1: `20'`,
      type2: `40'`,
      type3: '40HC',
      line: '欧洲线',
      company: 'MSK',
      num1: '17',
      num2: '13',
      num3: '0',
      lineDetail: [
        {
          start: 'XIAMEN',
          end: 'ANTWERP',
          date: Mock.Random.date('yyyy-MM-dd'),
          num1: '10',
          num2: '5',
          num3: '0'
        },
        {
          start: 'XIAMEN',
          end: 'ANTWERP',
          date: Mock.Random.date('yyyy-MM-dd'),
          num1: '2',
          num2: '6',
          num3: '0'
        },
        {
          start: 'XIAMEN',
          end: 'ANTWERP',
          date: Mock.Random.date('yyyy-MM-dd'),
          num1: '5',
          num2: '2',
          num3: '0'
        }
      ]
  },
  {
    id: '@increment', // 随机生成标识
    title: '订舱推荐',
    type1: `20'`,
    type2: `40'`,
    type3: '40HC',
    line: '东南亚线',
    company: 'OOCL',
    num1: '17',
    num2: '13',
    num3: '0',
    lineDetail: [
      {
        start: 'XIAMEN',
        end: 'ANTWERP',
        date: Mock.Random.date('yyyy-MM-dd'),
        num1: '10',
        num2: '5',
        num3: '0'
      },
      {
        start: 'XIAMEN',
        end: 'ANTWERP',
        date: Mock.Random.date('yyyy-MM-dd'),
        num1: '2',
        num2: '6',
        num3: '0'
      },
      {
        start: 'XIAMEN',
        end: 'ANTWERP',
        date: Mock.Random.date('yyyy-MM-dd'),
        num1: '5',
        num2: '2',
        num3: '0'
      }
    ]
},
];

module.exports = [
  {
    url: '/vue-element-admin/dashboard/getOpList',
    type: 'post',
    response: config => {
      return {
        code: 20000,
        data: {
          data: getOpList
        }
      }
    }
  },
  {
    url: '/vue-element-admin/dashboard/messageList',
    type: 'post',
    response: config => {
      return {
        code: 20000,
        data: {
          data: messageList
        }
      }
    }
  },
  {
    url: '/vue-element-admin/dashboard/getRecommendationList',
    type: 'post',
    response: config => {
      return {
        code: 20000,
        data: {
          data: getRecommendationList
        }
      }
    }
  },
]
